import { render, staticRenderFns } from "./xLinkCard.vue?vue&type=template&id=15c55a8c&"
import script from "./xLinkCard.vue?vue&type=script&lang=js&"
export * from "./xLinkCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports